.schemaTypeContainer {
  margin-top: 2.5rem;
}

.listContainer {
  display: grid;
  grid-template-columns: 2fr 1fr 1fr 1fr 1fr;

  & > div {
    padding: 2rem 1rem;
    font-size: 0.9rem;
  }

  & > div.listHeader {
    font-weight: 600;
    padding-bottom: 0.5rem;
  }

  & > div:nth-child(10n + 6),
  & > div:nth-child(10n + 7),
  & > div:nth-child(10n + 8),
  & > div:nth-child(10n + 9),
  & > div:nth-child(10n + 10) {
    background-color: var(--silver);
  }
}

.titleContainer {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
